import { Trans } from "@lingui/react/macro";
import { Box, Button, Stack, Text, ThemeIcon, Title } from "@mantine/core";
import { IconAlertTriangle, IconLogout, IconRefresh } from "@tabler/icons-react";
import { DataColumn } from "@/components/common/ui/datadisplay/DataColumn/DataColumn";
import { repair } from "@/utils/auth/repair";

export default function ErrorFallback() {
	return (
		<Stack h="100vh" justify="center" align="center" p="md">
			<ThemeIcon variant="transparent" size={64} color="red">
				<IconAlertTriangle style={{ width: "100%", height: "100%" }} />
			</ThemeIcon>

			<Title ta="center" order={1}>
				<Trans>Ha ocurrido un error inesperado</Trans>
			</Title>

			<DataColumn>
				<Text ta="center" size="lg">
					<Trans>
						Puedes intentar recargar la página o cerrar sesión para limpiar los datos.
					</Trans>
				</Text>
			</DataColumn>

			<Box>
				<Stack align="center">
					<Button
						size="lg"
						leftSection={<IconRefresh />}
						onClick={() => window.location.reload()}
					>
						<Trans>Recargar</Trans>
					</Button>

					<Button
						variant="subtle"
						color="red"
						leftSection={<IconLogout />}
						onClick={() => repair()}
					>
						<Trans>Cerrar sesión y reparar</Trans>
					</Button>
				</Stack>
			</Box>
		</Stack>
	);
}
